import { MutationTree } from "vuex";
import { TimeLineInt } from "./types";

export const mutations: MutationTree<TimeLineInt> = {
  TIMELINE_FULLFILED(state, payload: []) {
    state.data = payload;
  },
  RESET_TIMELINE(state) {
    state.data = [];
  },
  TIMELINE_REJECTED(state, payload: string) {
    state.error = payload;
  },
};
